(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('appStoreHelper', ["brandInfo", "feature", "grammarForPrefix", "modals", "modulesDao", "path", "wizardHelper", "$q", "commonDao", "$rootScope", function (brandInfo, feature, grammarForPrefix, modals, modulesDao, path, wizardHelper, $q, commonDao, $rootScope) {
        var linkForAutoMode = path('common').staticFile('AvananO365-ManualCreationOfMailConfigs.pdf');
        var linkForManualMode = path('common').staticFile('AvananO365-ManualCreationOfMailConfigs.pdf');
        var o365InstallationModalTitle = 'Installation Mode';
        var wizardScope;
        if (feature.checkpointTheme) {
            linkForAutoMode.path = 'https://supportcenter.checkpoint.com/supportcenter/portal?eventSubmit_doGoviewsolutiondetails=&solutionid=sk144213';
            linkForManualMode.path = 'https://sc1.checkpoint.com/documents/CloudGuard_SaaS_ManualConfiguration/html_frameset.htm';
            o365InstallationModalTitle = 'Office 365 Configuration Mode';
        } else if (feature.sonicwallTheme) {
            linkForAutoMode = path('common').staticFile('CAS_SaaS_Manually_Configuring_Office365.pdf');
            linkForManualMode = path('common').staticFile('CAS_SaaS_Manually_Configuring_Office365.pdf');
        }
        var textForO365AutoMode = '<strong>Automatic</strong>: The initial setup and future configuration changes in the ' + 'Exchange admin center will be performed by ' + grammarForPrefix.addAnOrA(brandInfo.getBrandLabel()) + ' service user.';
        var textForO365ManualMode = '<strong>Manual</strong>: The initial setup and any future configuration changes must ' + 'be done manually in the Exchange admin center. ' + brandInfo.getBrandLabel() + ' will not take any action ' + 'with a service user. Please contact support@' + brandInfo.getBrand() + '.com for assistance';
        // var textForAutoMode = '<strong>Automatic Mode</strong>: In this mode all Office 365 will be performed automatically. ' +
        //     'The following <a class="manual-mailflow-doc" target="_blank" href="' + linkForAutoMode.path +
        //     '"><strong>Link</strong></a> described the configurations applied to Office 365';
        // var textForManualMode = '<strong>Manual Mode</strong>: In this mode the system will not apply any changes to Office 365 and you will need to apply the configuration changes manually, ' +
        //     'during the install and when the policy changes. The following <a class="manual-mailflow-doc" target="_blank" href="' +
        //     linkForManualMode.path + '"><strong>Link</strong></a> described the required configuration changes';
        if (feature.checkpointTheme) {
            textForO365AutoMode = '<strong>Automatic Mode</strong><br>' + '<p class="manual-mailflow-mode">CloudGuard SaaS automatically configures your Office 365 account.<br>' + 'Click <a class="manual-mailflow-doc" target="_blank" href="' + linkForAutoMode.path + '">' + '<strong>here</strong></a> for more details.</p><p class="manual-mailflow-mode highlight">' + 'Important \u2013 a Global Admin Account will be created in your Exchange Admin Center. If you have ' + 'multi-factor enabled by default on Global Admin accounts, please contact ' + '<a class="manual-mailflow-doc" target="_blank" href="https://www.checkpoint.com/support-services/contact-support/">' + '<strong>Check Point Support</strong></a> or select Manual Mode.</p>';
            textForO365ManualMode = '<strong>Manual Mode</strong><br><p class="manual-mailflow-mode">You must manually ' + 'configure your Office 365 account to work with CloudGuard SaaS. Additional manual configuration will be ' + 'necessary for policy changes. Click <a class="manual-mailflow-doc" target="_blank" href="' + linkForManualMode.path + '"><strong>here</strong></a> for detailed instructions on how to manually ' + 'configure Office 365. (Your portal name is: <strong>' + brandInfo.customerSubdomain() + '</strong>).</p>';
        }
        var helper = {
            paramsForO365InstallationMode: function () {
                var modeParams = [{
                        id: 'config_mode_for_office365',
                        type: 'radio-group',
                        buttons: [
                            {
                                label: '#' + JSON.stringify({
                                    text: textForO365AutoMode,
                                    display: 'html'
                                }),
                                value: 'automatic'
                            },
                            {
                                label: '#' + JSON.stringify({
                                    text: textForO365ManualMode,
                                    display: 'html'
                                }),
                                value: 'manual'
                            }
                        ],
                        data: 'automatic',
                        paramClass: 'full-width-param o365-config-mode'
                    }];
                wizardScope = wizardHelper.scope();
                if (wizardScope && wizardScope.stepInfo.terms && !wizardScope.terms.accepted) {
                    modeParams.push({
                        id: 'accept_terms',
                        type: 'boolean',
                        rightLabel: '#' + JSON.stringify({
                            text: 'I Accept <a href="' + wizardScope.stepInfo.termsUrl + '" target="_blank" class="o365-terms-of-service-link" onClick="$event.stopPropagation()">Terms Of Service</a>',
                            display: 'html'
                        }),
                        linkedText: true,
                        paramClass: 'full-width-param o365-accept-terms'
                    });
                }
                return modeParams;
            },
            o365AppInstallationModal: function (options) {
                return modals.params([{
                        lastPage: true,
                        params: helper.paramsForO365InstallationMode()
                    }], o365InstallationModalTitle, 'md').then(function (data) {
                    var newObj = { manual_mailflow_config: false };
                    if (data.config_mode_for_office365 === 'manual') {
                        newObj.manual_mailflow_config = true;
                    }
                    if (wizardScope && wizardScope.stepInfo.terms && !wizardScope.terms.accepted) {
                        if (data.accept_terms) {
                            return $q.all([
                                commonDao.acceptTerms(),
                                modulesDao.saveConfig('office365_auth', newObj)
                            ]).then(function (responses) {
                                wizardScope.terms.accepted = responses[0].data;
                                wizardHelper.activateApp(options.moduleName);
                            });
                        } else {
                            return false;
                        }
                    }
                    return modulesDao.saveConfig('office365_auth', newObj).then(function () {
                        wizardHelper.activateApp(options.moduleName);
                    });
                });
            },
            shareFileAlert: function () {
                var modalParams = [
                    {
                        sentence: 'Upon clicking starting this app, ' + brandInfo.getBrandLabel() + ' will begin accessing files and folders as part of the security scan. ' + 'We recommend ensuring all folder/file download email notifications are turned off for all participating ShareFile ' + 'users. This will prevent automatic email-notifications for each scanned file.',
                        class: 'about-app-creation'
                    },
                    {
                        sentence: '#' + JSON.stringify({
                            text: 'More information about the email notifications: ' + '<a href="https://support.citrix.com/article/CTX208325#folder" target="_blank">click here</a>.',
                            display: 'html'
                        }),
                        class: 'about-app-creation'
                    },
                    {
                        sentence: '#' + JSON.stringify({
                            text: 'How to disable the email notifications: ' + '<a href="https://support.citrix.com/article/CTX208286?recommended" target="_blank">click here</a>.',
                            display: 'html'
                        }),
                        class: 'about-app-creation no-margin'
                    }
                ];
                var modalTitle = 'Important Warning';
                return modals.params([{
                        lastPage: true,
                        hideDefaultButton: false,
                        params: modalParams
                    }], modalTitle, 'md', {
                    backdrop: 'static',
                    keyboard: false,
                    hideCloseBtn: false,
                    windowClass: 'o365-mfa-modal-container'
                });
            },
            checkO365AuthorizedStatus: function (moduleName) {
                if (!wizardHelper.showActivateButton(moduleName)) {
                    $rootScope.o365Authorized = true;
                    return true;
                } else if ($rootScope.o365Authorized) {
                    return true;
                }
                return false;
            },
            isO365: function (moduleName) {
                return moduleName === 'office365_emails' || moduleName === 'office365_onedrive' || moduleName === 'office365_sharepoint';
            }
        };
        return helper;
    }]);
}());